import { KycProcessStatus } from 'further-types/kyc';

export enum KycStatusLabel {
  NotAttempted = 'Not attempted',
  DocumentUploadedByAdviser = 'Document(s) uploaded by adviser',
  InvestorResidencyFlag = 'Investor residency flag',
  NotApproved = 'Not approved',
  PassedWithManualKyb = 'Passed with manual KYB',
  Consider = 'Consider',
  InProgress = 'In progress',
  AwaitingResult = 'Awaiting result',
  Pass = 'Pass',
  EKycResetReattemptAvailable = 'eKYC reset, reattempt available',
  ManuallyReset = 'Manually reset',
  PassedWithEKycReview = 'Passed with eKYC review',
  PassedWithManualKyc = 'Passed with manual KYC',
}

export const kycProcessStatusLabels: Record<KycProcessStatus, KycStatusLabel> =
  {
    [KycProcessStatus.NotAttempted]: KycStatusLabel.NotAttempted,
    [KycProcessStatus.InProgress]: KycStatusLabel.InProgress,
    [KycProcessStatus.Processing]: KycStatusLabel.AwaitingResult,
    [KycProcessStatus.Passed]: KycStatusLabel.Pass,
    [KycProcessStatus.Reset]: KycStatusLabel.EKycResetReattemptAvailable,
    [KycProcessStatus.Failed]: KycStatusLabel.Consider,
    [KycProcessStatus.AdminApproved]: KycStatusLabel.PassedWithEKycReview,
    [KycProcessStatus.ManuallyApproved]: KycStatusLabel.PassedWithManualKyc,
  };

export const amlProcessStatusLabels: Record<KycProcessStatus, KycStatusLabel> =
  {
    ...kycProcessStatusLabels,
    [KycProcessStatus.Reset]: KycStatusLabel.ManuallyReset,
  };
